module.exports = __webpack_public_path__ + "media/images/country_flags/th-7d5743bc7f781f02afa824de01ba5d4b.png";